/** Coluna do quadro, vinda de WEB_STATUS_FLUXO. Rotulo e ordem sao dado, nunca constante no front. */
export interface KanbanStatus {
    id: number;
    nome: string;
    ordem: number;
    conclusivo: boolean;
    /** Sair desta coluna inicia o atendimento: exige responsavel e tramita o protocolo no portal. */
    iniciaAtendimento: boolean;
    /** Entrar nesta coluna oferece avisar o medico sobre a pendencia. Flag de banco, nunca o nome. */
    avisaPendencia: boolean;
}

/** Linha avulsa na tramitacao local, sem mover o card. */
export interface AnotarSolicitacaoRequest {
    ano: number;
    numero: number;
    texto: string;
    /** E-mail enviado, em HTML, quando a linha nasce de um aviso ao medico. */
    emailHtml?: string;
    /** Analista para quem o protocolo passa junto com a anotação. Opcional. */
    idWebUsuarioResponsavel?: number;
}

/** Criticidade do card. Rotulo e ordem vem do backend — nenhum nome vive em codigo. */
export interface KanbanCriticidade {
    id: number;
    nome: string;
    ordem: number;
}

/**
 * Uma linha da linha do tempo do protocolo. Movimentação traz `statusDestino`; anotação traz
 * `anotacao`. `statusOrigem` nulo numa movimentação é a entrada no fluxo.
 */
export interface HistoricoAndamento {
    dataHora?: string;
    statusOrigem?: string;
    statusDestino?: string;
    usuario?: string;
    usuarioDestino?: string;
    anotacao?: string;
    /** Id da anotação, quando a linha for uma. É por ele que a tela pede o e-mail guardado. */
    idAnotacao?: number;
    /** A anotação guarda o e-mail enviado ao médico. O HTML em si é buscado no clique. */
    temEmail?: boolean;
}

/** Foto de um responsável atribuído no quadro. Só vem para quem tem foto cadastrada. */
export interface FotoResponsavel {
    idWebUsuario: number;
    /** Conteúdo em Base64, sem prefixo de data URI. */
    fotoBase64: string;
}

/** Usuario elegivel a receber um encaminhamento. */
export interface Responsavel {
    idWebUsuario: number;
    nome: string;
}

/** Solicitacao ja rastreada. Protocolo sem entrada aqui e renderizado na primeira coluna. */
export interface KanbanSolicitacao {
    idSolicitacao: number;
    numero: number;
    ano: number;
    uf: string;
    idStatus: number;
    dtAbertura?: string;
    dtConclusao?: string;
    dtUltimaMovimentacao?: string;
    totalAnotacoes: number;
    idCriticidade: number;
    idWebUsuarioResponsavel?: number;
    nomeResponsavel?: string;
    /** Último aviso de pendência enviado ao médico; ausente quando nenhum saiu. */
    dtUltimoAviso?: string;
}

/**
 * Como um protocolo terminou, na letra que o backend grava em `WEB_SOLICITACAO.IN_DESFECHO`.
 *
 * Não há valor para "concluído sem saber como": ausência é o campo ausente, e ela significa
 * protocolo em aberto, conclusão anterior à coluna existir, ou conclusão que não passou pelo quadro.
 */
export enum EDesfechoSolicitacao {
    EFETIVADO = 'E',
    CANCELADO = 'C'
}

export interface MoverSolicitacaoRequest {
    idServico: number;
    numero: number;
    ano: number;
    uf: string;
    idStatusDestino: number;
    anotacao?: string;
    idWebUsuarioResponsavel?: number;
    /** Escolhida no diálogo. Ausente preserva a criticidade já gravada. */
    idCriticidade?: number;
    /**
     * Desfecho, quando ESTE movimento conclui o protocolo. Ausente em movimento que não conclui e em
     * `conclusiva -> conclusiva` (Concluído -> Arquivado), que não é um novo desfecho.
     *
     * O backend ignora o campo em destino não conclusivo, então enviá-lo por engano não corrompe
     * nada — mas deixar de enviá-lo numa conclusão perde o dado para sempre: não há de onde apurá-lo
     * depois.
     */
    desfecho?: EDesfechoSolicitacao;
}

export interface AlterarCriticidadeRequest {
    idServico: number;
    numero: number;
    ano: number;
    uf: string;
    idCriticidade: number;
}

export interface MoverSolicitacaoResponse {
    idSolicitacao: number;
    idStatus: number;
    dtConclusao?: string;
    dtUltimaMovimentacao?: string;
    /** Criticidade gravada. Um card recem-criado nasce com o padrao do banco, que o front nao conhece. */
    idCriticidade: number;
    idWebUsuarioResponsavel?: number;
}

/** Página do arquivo. `itens` vem no formato cru do portal, para passar pelo mesmo mapper dos cards. */
export interface ArquivadasPageResponse {
    total: number;
    itens: Record<string, unknown>[];
}

/** Totalizadores do arquivo inteiro (não do resultado da busca): alimentam os cartões de resumo da aba. */
export interface ArquivadasResumoResponse {
    total: number;
    concluidosNoAno: number;
    tempoMedioDias: number;
}
